/**
 * @generated SignedSource<<2b2780b564303c432465a5470ea204a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "ResetResponse",
    "kind": "LinkedField",
    "name": "reset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "resetComponentsResetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "resetComponentsResetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "abedf79a998fe3f0dd18eaf6a3f09004",
    "id": null,
    "metadata": {},
    "name": "resetComponentsResetMutation",
    "operationKind": "mutation",
    "text": "mutation resetComponentsResetMutation(\n  $request: ResetRequestInput\n) {\n  reset(request: $request) {\n    username\n  }\n}\n"
  }
};
})();

node.hash = "166d94631423491582adb36854615aec";

module.exports = node;
